import { ApiProperty } from "@nestjs/swagger";

export class CountRequest{
    @ApiProperty()
    count: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    productId?: number;
}